import React from "react";
import "../styleDotmatrix.css";
//import { currency } from "../../../MUI_components/currencyFormatterTag";
import { currency } from "../../../../MUI_components/currencyFormatterTag"
import { useSelector } from "react-redux";
import Receipts from "Components/Print/dot-invoice-receipt";
import { Grid } from "@mui/material";
import { width } from "@mui/system";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { TitumDetails } from "titum-layouts/shared-components/TitumDetails";
import BillHeader from "Components/Print/billHeaderDot";
import BillFooter from "Components/Print/BillFooterDot";


const Print = React.forwardRef((props, ref) => {

  const { invoiceCode, date } = useSelector((state) => state.lastInsertInvoice);
  // const printedDate = date ? new Date(date) : new Date();
  const today = new Date().toISOString().split("T")[0];
  const {returnedDiscount,submittedData} = props;
  const { customer, invoice, stockHistories } = submittedData;
  const discount = parseFloat(returnedDiscount);

  function roundToNearestTen(value) {
    let roundedValue;
    roundedValue = Math.floor(parseFloat(value) / 10) * 10;
    return roundedValue;
  }

  //Stock History Level
  // const handleLineTotal = (qty, price, discountPer, discountAmount) => {
  //   let totalAmount = qty * price;
  //   discountAmount = discountAmount * qty;
  //   let lineTotalAmount = totalAmount - totalAmount * (discountPer / 100) - discountAmount;
  //   return lineTotalAmount;
  // };

  //Invoice Level Calculations


  // const returnedTotal = returnData ? returnData
  //   .map((total) => total.totalAmount)
  //   .reduce((prev, curr) => prev + curr, 0) : ""

  return (

    <div className="printArea" ref={ref}>
      <>
      <div className="bill-page-header">
      
       <BillHeader /> 
     </div>
        <Receipts
        // date={date}
        // title={`INVOICE ${props.code && "RE-Printed"} - ${data.code ? data.code : props.invoiceCode
        //   }`

        // }
        >


          <table className="print-table-pos" style={{ marginTop: 20 }}>

            <div align="center"><strong>SALES RETURN</strong></div>
            <Grid container>
              <Grid item xs={5}>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        {customer?.code}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        To: {customer?.firstName}
                      </td>
                    </tr>
                    <tr>
                      <td >
                        {customer?.customerAddresses
                          .map((row) => (row.address))}
                      </td>
                    </tr>

                    <tr>
                      <td >
                        {/* {customer?.phone1 === '1111111111' ? "" : customer.phone1} */}

                      </td>
                    </tr>
                    <tr>
                      <td>
                        {COLUMNS_NAME.TYPE} : {submittedData.invoiceType == 1 ? "Take Away" : submittedData.invoiceType == 2 ? " Dine" : " Delivery"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Grid>


              <Grid item xs={4}>
                <table>
                  <tbody>
                  <tr>
                      <td>
                          {COLUMNS_NAME.SALES_RETURN_CODE} :  {invoice ? invoice.code : ""}
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                          {COLUMNS_NAME.RETURN_DATE} : {today}
                      </td>
                    </tr>
                    <tr>
                      <td>
                         {COLUMNS_NAME.INVOICE_NUMBER} : {invoice?.code} 
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {COLUMNS_NAME.INVOICE_DATE} : {invoice?.dateTime}
                      </td>
                    </tr>
                  
                  </tbody>
                </table>
              </Grid>




            </Grid></table>

          <table className="print-table-pos" style={{ marginTop: 10 }}>
            <div style={{ borderTop: "1px solid #24242450" }}></div>
            <table className="print-table-pos" style={{ marginRight: 100 }}>

              <thead>
                <tr
                  style={{
                    borderTop: "1px solid #24242450",
                    borderBottom: "1px solid #24242450",
                  }}>

                <th width="10">#</th>
                  <th align="left" width="100">
                    <strong>{COLUMNS_NAME.CODE}</strong>
                  </th>
                  <th align="left" width="250" >
                    <strong>{COLUMNS_NAME.DESCRIPTION}</strong>
                  </th>

                  <th align="center" width="90">
                    <strong>{COLUMNS_NAME.QUANTITY}</strong>
                  </th>
                  <th align="right" width="100">
                    <strong>{COLUMNS_NAME.AMOUNT} </strong></th>
                </tr>
              </thead>

              <tbody>

                {stockHistories.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{item.itemMaster?.barcode}</td>
                    <td><td align="center">{ item.name ? item.name : item.itemMaster ? item.itemMaster.name :  item.room.roomName }</td></td>
                    <td align="center">{item.quantity}</td>
                    <td align="right">{currency(item.unitSoldPrice ? item.unitSoldPrice :  item.retailPrice)}</td>
                    <td align="right">{currency(roundToNearestTen(item.totalAmount))}</td>

                  </tr>
                ))}
                 <tr>

                <td align="right" style={{ marginTop: 5 }} colSpan={4}>
                  <strong>{COLUMNS_NAME.TOTAL}</strong>
                </td>

                <td align="right" colSpan={2} >
                  <strong>{currency(roundToNearestTen(submittedData.totalAmount + discount))}</strong>
                </td>
              </tr>

                <tr>

                  <td align="right" style={{ marginTop: 5 }} colSpan={4}>
                    <strong>{COLUMNS_NAME.DISCOUNT}</strong>
                  </td>

                  <td align="right" colSpan={2} >
                    <strong>{currency(discount)}</strong>
                  </td>
                </tr>

                <tr>

                  <td align="right" style={{ marginTop: 5 }} colSpan={4}>
                    <strong>{COLUMNS_NAME.LAST_TOTAL}</strong>
                  </td>

                  <td align="right" colSpan={2} >
                    <strong>{currency(roundToNearestTen(submittedData.totalAmount))}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </table>
          {/*  Printed with Biz X */}
          <div style={{ borderTop: "1px solid #24242450" }}></div>

          <div className="row" style={{ marginTop: 50 }}>
            <div className="col-4">
              <div
                style={{
                  borderTop: "1px dashed #24242450",
                  textAlign: "center",
                }}
              >
                {COLUMNS_NAME.PREPAIRED_BY}
              </div>
            </div>


            <div className="col-4">
              <div
                style={{
                  borderTop: "1px dashed #24242450",
                  textAlign: "center",
                }}
              >
                {COLUMNS_NAME.CHECKED_BY}
              </div>
            </div>

            <div className="col-4">
              <div
                style={{
                  borderTop: "1px dashed #24242450",
                  textAlign: "center",
                }}
              >
                Customer Acceptance
              </div>
            </div>
          </div>

          {/* <div className="col-12">
            <div
              style={{
                textAlign: "center",
              }}
            >
              `{TitumDetails.SOLUTION_BY} | {TitumDetails.WEB} | {TitumDetails.EMAIL_ID}`

            </div></div> */}


        </Receipts>
        <div className="page-footer">
           <BillFooter/> 
      </div>
      </>
    </div >

  );
});

export default Print;